export default "__VITE_ASSET__onPMRaZ0__"